if (typeof window.AESupportFaq !== 'function') {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class AESupportFaq extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.singleOpen = this.dataset.singleOpen !== 'false';
      this.items = Array.from(this.querySelectorAll('details.ae-support-faq__item'));
      if (this.items.length === 0) return;

      this.items.forEach((item) => {
        const summary = item.querySelector('summary.ae-support-faq__trigger');
        const panel = item.querySelector('.ae-support-faq__panel');
        if (!summary || !panel) return;

        if (item.open) {
          panel.style.height = 'auto';
          panel.style.opacity = '1';
        } else {
          panel.style.height = '0px';
          panel.style.opacity = '0';
        }

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(item, panel);
        });
      });
    }

    toggle(item, panel) {
      if (item.open) {
        this.close(item, panel);
        return;
      }

      if (this.singleOpen) {
        this.items.forEach((other) => {
          if (other !== item && other.open) {
            this.close(other, other.querySelector('.ae-support-faq__panel'));
          }
        });
      }

      this.open(item, panel);
    }

    open(item, panel) {
      item.open = true;

      if (!panel) return;

      if (reducedMotion()) {
        panel.style.transition = '';
        panel.style.height = 'auto';
        panel.style.opacity = '1';
        return;
      }

      panel.style.transition = '';
      panel.style.height = '0px';
      panel.style.opacity = '0';

      requestAnimationFrame(() => {
        const target = panel.scrollHeight;
        panel.style.transition = 'height 320ms cubic-bezier(0.4,0,0.2,1), opacity 220ms cubic-bezier(0.4,0,0.2,1)';
        panel.style.height = `${target}px`;
        panel.style.opacity = '1';

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.style.transition = '';
          panel.style.height = 'auto';
        };
        panel.addEventListener('transitionend', onEnd);
      });
    }

    close(item, panel) {
      if (!panel) {
        item.open = false;
        return;
      }

      if (reducedMotion()) {
        panel.style.transition = '';
        panel.style.height = '0px';
        panel.style.opacity = '0';
        item.open = false;
        return;
      }

      const start = panel.getBoundingClientRect().height;
      panel.style.transition = '';
      panel.style.height = `${start}px`;
      panel.style.opacity = '1';

      requestAnimationFrame(() => {
        panel.style.transition = 'height 300ms cubic-bezier(0.4,0,0.2,1), opacity 180ms cubic-bezier(0.4,0,0.2,1)';
        panel.style.height = '0px';
        panel.style.opacity = '0';

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.style.transition = '';
          item.open = false;
        };
        panel.addEventListener('transitionend', onEnd);
      });
    }
  }

  window.AESupportFaq = AESupportFaq;
  customElements.define('ae-support-faq', AESupportFaq);
}
